import { useMutation } from 'react-query';
import { mutationPostForm } from '~/services/acquisition';
import { getLogger } from '~/utils/logger';
import type { ResultError, ResultSuccess, FormData } from '~/services/acquisition';

type Props = {
  onSuccess?: (data: ResultSuccess) => void;
  onError?: (error: ResultError) => void;
};

export const useAcquisitionPostForms = ({ onSuccess, onError }: Props = {}) => {
  const mutation = useMutation({
    mutationFn: (formData: FormData) => {
      return mutationPostForm(formData);
    },
    onSuccess: (success: ResultSuccess) => {
      getLogger().info('[useAcquisitionPostForms] - mutationPostForm', success);
      onSuccess?.(success);
    },
    onError: (error: ResultError) => {
      getLogger().error('[useAcquisitionPostForms] - mutationPostForm', error);
      onError?.(error);
    },
  });

  return mutation;
};
